"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const ListView_1 = __importDefault(require("@/components/data/ListView"));
const plugin_1 = require("@/plugin");
const mainData_1 = __importDefault(require("./../mainData"));
const redeemFlowConfig_1 = require("../redeemFlowConfig");
exports.default = (0, vue_1.defineComponent)({
    name: 'RedeemList',
    components: {
        ListView: ListView_1.default
    },
    data() {
        return {
            mainData: mainData_1.default,
            listOption: {
                table: {
                    optionProps: {
                        bordered: true,
                        scroll: {
                            x: this.getWidth()
                        }
                    }
                },
                search: {
                // layout: 'horizontal'
                },
                searchMenu: [
                    {
                        prop: 'setSearch',
                        name: '查询',
                        type: 'primary'
                    },
                    {
                        prop: 'resetSearch',
                        name: '重置',
                        type: 'default'
                    }
                ],
                menu: {
                    list: [
                        {
                            prop: 'change-emit',
                            name: '详情'
                        },
                        {
                            prop: 'settlement',
                            name: '逾期结清',
                            hidden({ record }) {
                                // 审批状态 = 通过 车辆赎回类型 = 赎回结清
                                if (record.applyStatus.value === '2' && record.redemptionType.value === '2') {
                                    return false;
                                }
                                else {
                                    return true;
                                }
                            }
                        },
                    ]
                }
            }
        };
    },
    computed: {
        width() {
            return this.getWidth();
        }
    },
    mounted() {
        this.mainData.$loadData(true);
    },
    beforeUnmount() {
        mainData_1.default.$reset();
    },
    methods: {
        getWidth() {
            return plugin_1.reactiveLayout.data.main.width - 16 * 2;
        },
        onMenu(from, act, payload) {
            if (from === 'table') {
                if (act === 'change-emit') {
                    (0, redeemFlowConfig_1.toRedeemInfo)(payload.record.id, '0', 'end');
                }
                else if (act === 'settlement') {
                    this.mainData.$triggerMethod('settleItem', [payload.record]);
                }
            }
        }
    }
});
